module.exports = __webpack_public_path__ + "img/zhuanli8.e8c95ec6.png";